const tableData = {
    heard: {
        p:
            'Panelists were asked whether they have heard of the 36 political sources for news about government and politics. The sortable table below shows the share of online adults in each generation who have heard of each of the sources in the study.',
        h1: 'Awareness of News Sources',
        h2: '% of respondents who have heard of each source',
        data: [
            {
                Source: 'ABC News',
                Millennial: '92',
                'Generation X': '96',
                'Baby Boomer': '95',
            },
            {
                Source: 'Al Jazeera America',
                Millennial: '32',
                'Generation X': '46',
                'Baby Boomer': '50',
            },
            {
                Source: 'BBC',
                Millennial: '74',
                'Generation X': '79',
                'Baby Boomer': '76',
            },
            {
                Source: 'Bloomberg',
                Millennial: '45',
                'Generation X': '70',
                'Baby Boomer': '67',
            },
            {
                Source: 'Breitbart',
                Millennial: '8',
                'Generation X': '17',
                'Baby Boomer': '19',
            },
            {
                Source: 'BuzzFeed',
                Millennial: '40',
                'Generation X': '32',
                'Baby Boomer': '26',
            },
            {
                Source: 'CBS News',
                Millennial: '90',
                'Generation X': '95',
                'Baby Boomer': '95',
            },
            {
                Source: 'CNN',
                Millennial: '95',
                'Generation X': '95',
                'Baby Boomer': '95',
            },
            {
                Source: 'Colbert Report',
                Millennial: '62',
                'Generation X': '67',
                'Baby Boomer': '59',
            },
            {
                Source: 'Daily Kos',
                Millennial: '8',
                'Generation X': '16',
                'Baby Boomer': '15',
            },
            {
                Source: 'Daily Show',
                Millennial: '69',
                'Generation X': '70',
                'Baby Boomer': '58',
            },
            {
                Source: 'Drudge Report',
                Millennial: '22',
                'Generation X': '40',
                'Baby Boomer': '39',
            },
            {
                Source: 'Economist',
                Millennial: '32',
                'Generation X': '38',
                'Baby Boomer': '35',
            },
            {
                Source: 'Ed Schultz Show',
                Millennial: '11',
                'Generation X': '14',
                'Baby Boomer': '19',
            },
            {
                Source: 'Fox News',
                Millennial: '92',
                'Generation X': '94',
                'Baby Boomer': '93',
            },
            {
                Source: 'Glenn Beck Program',
                Millennial: '34',
                'Generation X': '53',
                'Baby Boomer': '58',
            },
            {
                Source: 'Google News',
                Millennial: '78',
                'Generation X': '72',
                'Baby Boomer': '66',
            },
            {
                Source: 'Guardian',
                Millennial: '33',
                'Generation X': '37',
                'Baby Boomer': '38',
            },
            {
                Source: 'Huffington Post',
                Millennial: '62',
                'Generation X': '70',
                'Baby Boomer': '66',
            },
            {
                Source: 'MSNBC',
                Millennial: '86',
                'Generation X': '91',
                'Baby Boomer': '92',
            },
            {
                Source: 'Mother Jones',
                Millennial: '11',
                'Generation X': '22',
                'Baby Boomer': '31',
            },
            {
                Source: 'NBC News',
                Millennial: '92',
                'Generation X': '95',
                'Baby Boomer': '95',
            },
            {
                Source: 'NPR',
                Millennial: '45',
                'Generation X': '57',
                'Baby Boomer': '56',
            },
            {
                Source: 'New York Times',
                Millennial: '82',
                'Generation X': '89',
                'Baby Boomer': '83',
            },
            {
                Source: 'New Yorker',
                Millennial: '59',
                'Generation X': '69',
                'Baby Boomer': '68',
            },
            {
                Source: 'PBS',
                Millennial: '85',
                'Generation X': '92',
                'Baby Boomer': '88',
            },
            {
                Source: 'Politico',
                Millennial: '20',
                'Generation X': '37',
                'Baby Boomer': '38',
            },
            {
                Source: 'Rush Limbaugh Show',
                Millennial: '47',
                'Generation X': '75',
                'Baby Boomer': '76',
            },
            {
                Source: 'Sean Hannity Show',
                Millennial: '30',
                'Generation X': '50',
                'Baby Boomer': '53',
            },
            {
                Source: 'Slate',
                Millennial: '16',
                'Generation X': '25',
                'Baby Boomer': '23',
            },
            {
                Source: 'TheBlaze',
                Millennial: '12',
                'Generation X': '21',
                'Baby Boomer': '22',
            },
            {
                Source: 'ThinkProgress',
                Millennial: '10',
                'Generation X': '10',
                'Baby Boomer': '7',
            },
            {
                Source: 'USA Today',
                Millennial: '84',
                'Generation X': '94',
                'Baby Boomer': '92',
            },
            {
                Source: 'Wall Street Journal',
                Millennial: '73',
                'Generation X': '88',
                'Baby Boomer': '85',
            },
            {
                Source: 'Washington Post',
                Millennial: '72',
                'Generation X': '84',
                'Baby Boomer': '83',
            },
            {
                Source: 'Yahoo News',
                Millennial: '85',
                'Generation X': '83',
                'Baby Boomer': '77',
            },
        ],
    },
    consume: {
        p:
            'Panelists were asked whether, over the course of the previous week, they got news about government and politics from each of the 42 sources  (the same 36 sources asked about for awareness and trust, as well as local television and five social networking sites). The sortable table below shows where online Millennials, Gen Xers and Baby Boomers turn to for political and government news.',
        h1: 'Consumption of News Sources',
        h2:
            '% of respondents who got news about politics and government in the previous week from each source',
        data: [
            {
                Source: 'ABC News',
                Millennial: '32',
                'Generation X': '32',
                'Baby Boomer': '44',
            },
            {
                Source: 'Al Jazeera America',
                Millennial: '4',
                'Generation X': '4',
                'Baby Boomer': '5',
            },
            {
                Source: 'BBC',
                Millennial: '16',
                'Generation X': '16',
                'Baby Boomer': '18',
            },
            {
                Source: 'Bloomberg',
                Millennial: '3',
                'Generation X': '4',
                'Baby Boomer': '6',
            },
            {
                Source: 'Breitbart',
                Millennial: '1',
                'Generation X': '3',
                'Baby Boomer': '4',
            },
            {
                Source: 'BuzzFeed',
                Millennial: '8',
                'Generation X': '2',
                'Baby Boomer': '3',
            },
            {
                Source: 'CBS News',
                Millennial: '19',
                'Generation X': '27',
                'Baby Boomer': '39',
            },
            {
                Source: 'CNN',
                Millennial: '44',
                'Generation X': '45',
                'Baby Boomer': '43',
            },
            {
                Source: 'Colbert Report',
                Millennial: '15',
                'Generation X': '8',
                'Baby Boomer': '7',
            },
            {
                Source: 'Daily Kos',
                Millennial: '1',
                'Generation X': '2',
                'Baby Boomer': '3',
            },
            {
                Source: 'Daily Show',
                Millennial: '16',
                'Generation X': '10',
                'Baby Boomer': '10',
            },
            {
                Source: 'Drudge Report',
                Millennial: '2',
                'Generation X': '5',
                'Baby Boomer': '6',
            },
            {
                Source: 'Economist',
                Millennial: '4',
                'Generation X': '3',
                'Baby Boomer': '4',
            },
            {
                Source: 'Ed Schultz Show',
                Millennial: '*',
                'Generation X': '1',
                'Baby Boomer': '3',
            },
            {
                Source: 'Facebook',
                Millennial: '61',
                'Generation X': '51',
                'Baby Boomer': '39',
            },
            {
                Source: 'Fox News',
                Millennial: '30',
                'Generation X': '36',
                'Baby Boomer': '47',
            },
            {
                Source: 'Glenn Beck Program',
                Millennial: '2',
                'Generation X': '7',
                'Baby Boomer': '9',
            },
            {
                Source: 'Google News',
                Millennial: '33',
                'Generation X': '18',
                'Baby Boomer': '15',
            },
            {
                Source: 'Google Plus',
                Millennial: '7',
                'Generation X': '6',
                'Baby Boomer': '4',
            },
            {
                Source: 'Guardian',
                Millennial: '4',
                'Generation X': '4',
                'Baby Boomer': '3',
            },
            {
                Source: 'Huffington Post',
                Millennial: '12',
                'Generation X': '16',
                'Baby Boomer': '13',
            },
            {
                Source: 'LinkedIn',
                Millennial: '2',
                'Generation X': '3',
                'Baby Boomer': '4',
            },
            {
                Source: 'Local TV News',
                Millennial: '37',
                'Generation X': '46',
                'Baby Boomer': '60',
            },
            {
                Source: 'MSNBC',
                Millennial: '22',
                'Generation X': '27',
                'Baby Boomer': '33',
            },
            {
                Source: 'Mother Jones',
                Millennial: '2',
                'Generation X': '1',
                'Baby Boomer': '3',
            },
            {
                Source: 'NBC News',
                Millennial: '27',
                'Generation X': '35',
                'Baby Boomer': '47',
            },
            {
                Source: 'NPR',
                Millennial: '18',
                'Generation X': '21',
                'Baby Boomer': '22',
            },
            {
                Source: 'New York Times',
                Millennial: '17',
                'Generation X': '9',
                'Baby Boomer': '12',
            },
            {
                Source: 'New Yorker',
                Millennial: '3',
                'Generation X': '2',
                'Baby Boomer': '4',
            },
            {
                Source: 'PBS',
                Millennial: '9',
                'Generation X': '12',
                'Baby Boomer': '26',
            },
            {
                Source: 'Politico',
                Millennial: '3',
                'Generation X': '4',
                'Baby Boomer': '5',
            },
            {
                Source: 'Rush Limbaugh Show',
                Millennial: '3',
                'Generation X': '7',
                'Baby Boomer': '12',
            },
            {
                Source: 'Sean Hannity Show',
                Millennial: '3',
                'Generation X': '8',
                'Baby Boomer': '13',
            },
            {
                Source: 'Slate',
                Millennial: '2',
                'Generation X': '3',
                'Baby Boomer': '3',
            },
            {
                Source: 'TheBlaze',
                Millennial: '2',
                'Generation X': '7',
                'Baby Boomer': '7',
            },
            {
                Source: 'ThinkProgress',
                Millennial: '1',
                'Generation X': '1',
                'Baby Boomer': '1',
            },
            {
                Source: 'Twitter',
                Millennial: '14',
                'Generation X': '9',
                'Baby Boomer': '5',
            },
            {
                Source: 'USA Today',
                Millennial: '10',
                'Generation X': '11',
                'Baby Boomer': '14',
            },
            {
                Source: 'Wall Street Journal',
                Millennial: '9',
                'Generation X': '9',
                'Baby Boomer': '12',
            },
            {
                Source: 'Washington Post',
                Millennial: '8',
                'Generation X': '7',
                'Baby Boomer': '8',
            },
            {
                Source: 'Yahoo News',
                Millennial: '27',
                'Generation X': '25',
                'Baby Boomer': '21',
            },
            {
                Source: 'YouTube',
                Millennial: '23',
                'Generation X': '11',
                'Baby Boomer': '10',
            },
        ],
    },
    trust: {
        p:
            'Panelists were asked whether they trust the 36 sources for news about government and politics. The sortable table below shows the share of online adults in each generation who trust each of the sources in the study.',
        h1: 'Trust of News Sources',
        h2: '% of respondents saying they trust each source',
        data: [
            {
                Source: 'ABC News',
                Millennial: '48',
                'Generation X': '53',
                'Baby Boomer': '53',
            },
            {
                Source: 'Al Jazeera America',
                Millennial: '10',
                'Generation X': '8',
                'Baby Boomer': '8',
            },
            {
                Source: 'BBC',
                Millennial: '37',
                'Generation X': '36',
                'Baby Boomer': '35',
            },
            {
                Source: 'Bloomberg',
                Millennial: '9',
                'Generation X': '11',
                'Baby Boomer': '13',
            },
            {
                Source: 'Breitbart',
                Millennial: '1',
                'Generation X': '4',
                'Baby Boomer': '7',
            },
            {
                Source: 'BuzzFeed',
                Millennial: '4',
                'Generation X': '1',
                'Baby Boomer': '2',
            },
            {
                Source: 'CBS News',
                Millennial: '41',
                'Generation X': '48',
                'Baby Boomer': '50',
            },
            {
                Source: 'CNN',
                Millennial: '60',
                'Generation X': '55',
                'Baby Boomer': '50',
            },
            {
                Source: 'Colbert Report',
                Millennial: '22',
                'Generation X': '13',
                'Baby Boomer': '12',
            },
            {
                Source: 'Daily Kos',
                Millennial: '1',
                'Generation X': '2',
                'Baby Boomer': '3',
            },
            {
                Source: 'Daily Show',
                Millennial: '23',
                'Generation X': '15',
                'Baby Boomer': '13',
            },
            {
                Source: 'Drudge Report',
                Millennial: '4',
                'Generation X': '7',
                'Baby Boomer': '11',
            },
            {
                Source: 'Economist',
                Millennial: '14',
                'Generation X': '11',
                'Baby Boomer': '11',
            },
            {
                Source: 'Ed Schultz Show',
                Millennial: '1',
                'Generation X': '2',
                'Baby Boomer': '5',
            },
            {
                Source: 'Fox News',
                Millennial: '35',
                'Generation X': '44',
                'Baby Boomer': '51',
            },
            {
                Source: 'Glenn Beck Program',
                Millennial: '3',
                'Generation X': '11',
                'Baby Boomer': '16',
            },
            {
                Source: 'Google News',
                Millennial: '38',
                'Generation X': '20',
                'Baby Boomer': '17',
            },
            {
                Source: 'Guardian',
                Millennial: '8',
                'Generation X': '6',
                'Baby Boomer': '7',
            },
            {
                Source: 'Huffington Post',
                Millennial: '20',
                'Generation X': '19',
                'Baby Boomer': '15',
            },
            {
                Source: 'MSNBC',
                Millennial: '37',
                'Generation X': '41',
                'Baby Boomer': '39',
            },
            {
                Source: 'Mother Jones',
                Millennial: '3',
                'Generation X': '5',
                'Baby Boomer': '8',
            },
            {
                Source: 'NBC News',
                Millennial: '47',
                'Generation X': '51',
                'Baby Boomer': '53',
            },
            {
                Source: 'NPR',
                Millennial: '28',
                'Generation X': '30',
                'Baby Boomer': '29',
            },
            {
                Source: 'New York Times',
                Millennial: '41',
                'Generation X': '31',
                'Baby Boomer': '28',
            },
            {
                Source: 'New Yorker',
                Millennial: '15',
                'Generation X': '13',
                'Baby Boomer': '15',
            },
            {
                Source: 'PBS',
                Millennial: '34',
                'Generation X': '37',
                'Baby Boomer': '42',
            },
            {
                Source: 'Politico',
                Millennial: '7',
                'Generation X': '6',
                'Baby Boomer': '7',
            },
            {
                Source: 'Rush Limbaugh Show',
                Millennial: '4',
                'Generation X': '12',
                'Baby Boomer': '18',
            },
            {
                Source: 'Sean Hannity Show',
                Millennial: '3',
                'Generation X': '12',
                'Baby Boomer': '18',
            },
            {
                Source: 'Slate',
                Millennial: '3',
                'Generation X': '4',
                'Baby Boomer': '4',
            },
            {
                Source: 'TheBlaze',
                Millennial: '2',
                'Generation X': '7',
                'Baby Boomer': '9',
            },
            {
                Source: 'ThinkProgress',
                Millennial: '3',
                'Generation X': '2',
                'Baby Boomer': '2',
            },
            {
                Source: 'USA Today',
                Millennial: '33',
                'Generation X': '33',
                'Baby Boomer': '35',
            },
            {
                Source: 'Wall Street Journal',
                Millennial: '28',
                'Generation X': '31',
                'Baby Boomer': '34',
            },
            {
                Source: 'Washington Post',
                Millennial: '25',
                'Generation X': '30',
                'Baby Boomer': '27',
            },
            {
                Source: 'Yahoo News',
                Millennial: '25',
                'Generation X': '19',
                'Baby Boomer': '17',
            },
        ],
    },
    distrust: {
        p:
            'Panelists were asked whether they distrust the 36 sources for news about government and politics. The sortable table below shows the share of online adults in each generation who distrust each of the sources in the study.',
        h1: 'Distrust of News Sources',
        h2: '% of respondents saying they distrust each source',
        data: [
            {
                Source: 'ABC News',
                Millennial: '14',
                'Generation X': '13',
                'Baby Boomer': '19',
            },
            {
                Source: 'Al Jazeera America',
                Millennial: '6',
                'Generation X': '17',
                'Baby Boomer': '22',
            },
            {
                Source: 'BBC',
                Millennial: '9',
                'Generation X': '7',
                'Baby Boomer': '6',
            },
            {
                Source: 'Bloomberg',
                Millennial: '6',
                'Generation X': '8',
                'Baby Boomer': '9',
            },
            {
                Source: 'Breitbart',
                Millennial: '3',
                'Generation X': '5',
                'Baby Boomer': '4',
            },
            {
                Source: 'BuzzFeed',
                Millennial: '14',
                'Generation X': '7',
                'Baby Boomer': '4',
            },
            {
                Source: 'CBS News',
                Millennial: '13',
                'Generation X': '15',
                'Baby Boomer': '20',
            },
            {
                Source: 'CNN',
                Millennial: '16',
                'Generation X': '17',
                'Baby Boomer': '25',
            },
            {
                Source: 'Colbert Report',
                Millennial: '14',
                'Generation X': '19',
                'Baby Boomer': '15',
            },
            {
                Source: 'Daily Kos',
                Millennial: '2',
                'Generation X': '4',
                'Baby Boomer': '4',
            },
            {
                Source: 'Daily Show',
                Millennial: '16',
                'Generation X': '21',
                'Baby Boomer': '18',
            },
            {
                Source: 'Drudge Report',
                Millennial: '7',
                'Generation X': '11',
                'Baby Boomer': '9',
            },
            {
                Source: 'Economist',
                Millennial: '2',
                'Generation X': '3',
                'Baby Boomer': '2',
            },
            {
                Source: 'Ed Schultz Show',
                Millennial: '3',
                'Generation X': '6',
                'Baby Boomer': '7',
            },
            {
                Source: 'Fox News',
                Millennial: '43',
                'Generation X': '37',
                'Baby Boomer': '32',
            },
            {
                Source: 'Glenn Beck Program',
                Millennial: '21',
                'Generation X': '27',
                'Baby Boomer': '26',
            },
            {
                Source: 'Google News',
                Millennial: '13',
                'Generation X': '11',
                'Baby Boomer': '9',
            },
            {
                Source: 'Guardian',
                Millennial: '5',
                'Generation X': '4',
                'Baby Boomer': '4',
            },
            {
                Source: 'Huffington Post',
                Millennial: '14',
                'Generation X': '19',
                'Baby Boomer': '19',
            },
            {
                Source: 'MSNBC',
                Millennial: '15',
                'Generation X': '23',
                'Baby Boomer': '26',
            },
            {
                Source: 'Mother Jones',
                Millennial: '2',
                'Generation X': '5',
                'Baby Boomer': '7',
            },
            {
                Source: 'NBC News',
                Millennial: '15',
                'Generation X': '17',
                'Baby Boomer': '22',
            },
            {
                Source: 'NPR',
                Millennial: '4',
                'Generation X': '11',
                'Baby Boomer': '12',
            },
            {
                Source: 'New York Times',
                Millennial: '11',
                'Generation X': '16',
                'Baby Boomer': '20',
            },
            {
                Source: 'New Yorker',
                Millennial: '9',
                'Generation X': '10',
                'Baby Boomer': '12',
            },
            {
                Source: 'PBS',
                Millennial: '12',
                'Generation X': '10',
                'Baby Boomer': '14',
            },
            {
                Source: 'Politico',
                Millennial: '2',
                'Generation X': '6',
                'Baby Boomer': '9',
            },
            {
                Source: 'Rush Limbaugh Show',
                Millennial: '32',
                'Generation X': '43',
                'Baby Boomer': '42',
            },
            {
                Source: 'Sean Hannity Show',
                Millennial: '17',
                'Generation X': '23',
                'Baby Boomer': '23',
            },
            {
                Source: 'Slate',
                Millennial: '2',
                'Generation X': '3',
                'Baby Boomer': '4',
            },
            {
                Source: 'TheBlaze',
                Millennial: '3',
                'Generation X': '3',
                'Baby Boomer': '3',
            },
            {
                Source: 'ThinkProgress',
                Millennial: '2',
                'Generation X': '3',
                'Baby Boomer': '2',
            },
            {
                Source: 'USA Today',
                Millennial: '9',
                'Generation X': '15',
                'Baby Boomer': '13',
            },
            {
                Source: 'Wall Street Journal',
                Millennial: '7',
                'Generation X': '11',
                'Baby Boomer': '11',
            },
            {
                Source: 'Washington Post',
                Millennial: '9',
                'Generation X': '13',
                'Baby Boomer': '18',
            },
            {
                Source: 'Yahoo News',
                Millennial: '19',
                'Generation X': '16',
                'Baby Boomer': '14',
            },
        ],
    },
};

export default tableData;
